/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'
import _ from 'underscore'
import { camelize } from 'underscore.string'

const SubModel = self => {
  /**
   * @namespace Model
   * @mixin
   * @param {string} attributes - The attribute that will become a submodel
   * @param {object} options - Additional options
   * @param {object} options.model - The model class to be used when creating the submodel
   * @param {string} options.prefix - The prefix to use when attaching the submodel
   */
  return {
    initSubModel (attribute, options = {}) {
      options = _.defaults(options, {
        model: Backbone.Model,
        prefix: ''
      })

      // Create a backbone model simply to get change events
      const varName = camelize(attribute)
      const subModel = new options.model(self.get(attribute)) // eslint-disable-line new-cap

      self[`${options.prefix}${varName}`] = subModel
      self.set(attribute, subModel.toJSON({ root: false }), { silent: true })

      // Propagate the model change events to the parent
      self.listenTo(subModel, 'change', function (model) {
        _.each(model.changedAttributes(), (v, k) => {
          // Arguments are 'backwards' due a version being live
          // that didn't include the model
          self.trigger(`change:${attribute}:${k}`, v, subModel)
        })

        /*
         * Update the attributes so that toJSON always reflects the
         * correct attributes when a submodel attribute has changed
         */
        self.set(attribute, subModel.toJSON({ root: false }), { silent: true })

        // Trigger change event on the parent model.
        self.trigger('change', self)
      })

      /*
       * When hash is updated, propagate its change into the submodel.
       * This typically happens when you're updating data from the server.
       */
      self.on(`change:${attribute}`, () => subModel.set(self.get(attribute)))

      return subModel
    }
  }
}

export default SubModel
